// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__39JFF"};